import { Link } from 'react-router-dom'
const NavItem = (props) => {
    return(
        <li className="nav-item">
            {props.name === "Blog" ? (
                <a href={props.to} className="nav-link" target="_blank" rel="noreferrer">{props.name}</a>
            ) : (
                <Link to={props.to} className="nav-link">{props.name}</Link>
            )}
            
        </li>
    )
}

export default NavItem